import { environment } from "src/environments/environment"

export class LoginRequest {
	client_id: string
	client_secret: string
	grant_type: string
	token: string

	constructor(model?: any) {
		this.client_id = environment.client_id
		this.client_secret = environment.client_secret
		this.grant_type = "https://openfiber.it/grants/token"
		this.token = model.token
	}
}
